import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { IncentiveStore, IUserEngagements } from './types'

export const useIncentiveStore = create<IncentiveStore>()(
  devtools(set => ({
    getUserEngagements: async (userId: number) => {
      try {
        const response = await http.get(`/incentive/user/${userId}/engagements`)

        return (response as IUserEngagements) ?? null
      } catch (error) {
        console.error('Error fetching user engagements:', error)
        return null
      }
    },

    requestNewCard: async (
      userId: number
    ): Promise<{ success: boolean; errorMessage?: string }> => {
      try {
        const endpoint = `/incentive/user/${userId}/request_new_card`
        // the endpoint answers failures with a body, so read it instead of throwing
        const response = await http.post(endpoint, undefined, {
          validateStatus: () => true
        })
        return {
          success: !!response?.success,
          errorMessage: response?.errorMessage || undefined
        }
      } catch (error) {
        return { success: false }
      }
    }
  }))
)
